/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRings = createReactComponent("outline", "rings", "IconRings", [["path", { "d": "M7 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M7 15v-11", "key": "svg-2" }], ["path", { "d": "M17 15v-11", "key": "svg-3" }], ["path", { "d": "M3 4h18", "key": "svg-4" }]]);

export { IconRings as default };
//# sourceMappingURL=IconRings.mjs.map
